
export const config = {
    abiStoreUrl: ''
};
